import { graphql } from 'react-relay';
import { useEffect } from 'react';
import { nanoid } from 'nanoid';
import { useSpacePublicZustandStore } from '@/helpers/spacepublicprovider';
import miniQueryLoader from '@/helpers/miniQueryLoaderv3';

const queryContentData = graphql`
  query lazyContentDataQuery($spaceRef: String!) {
    item : getSpaceByRef(ref: $spaceRef) {
      calendar {
        ...calendarSpaceCalendar_calendar
      }
      diary {
        dateKey
        category
        riders
        period
      }
      diaryperhour
    }
  }
`;

function ComponentContentData({ data }) {
  useEffect(() => {
    if (data?.item?.calendar) {
      useSpacePublicZustandStore.setState({
        lazycontentdataloaded: nanoid(),
        lazyDiary: data?.item?.diary,
        lazyDiaryPerHour: data?.item?.diaryperhour,
        lazyCalendar: data?.item?.calendar,
      });
    }
  }, [data]);

  return null;
}

const MiniQLoaderComponent = miniQueryLoader({
  Component: ComponentContentData,
  query: queryContentData,
  providerVariables: ({ spaceRef }) => ({ spaceRef }),
});

export default function ComponentRoot({ spaceRef }) {
  return <MiniQLoaderComponent key={`lazyContentDataMiniQLoaderComponent${spaceRef}`} spaceRef={spaceRef} />;
}
